// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';
import { v1WebhookSchema } from './v1/webhookSchema';
import { v1WebhooksUpdateSchema } from './v1/webhooks/updateSchema';

export const updateWebhookPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Webhook ID"),
});

export const updateWebhookHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Webhook updated successfully
 */
export const updateWebhook200Schema = z.lazy(() => v1WebhookSchema);

/**
 * @description Webhook not found
 */
export const updateWebhook404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Validation errors
 */
export const updateWebhook422Schema = z.lazy(() => v1ValidationErrorSchema);

export const updateWebhookMutationRequestSchema = z.lazy(() => v1WebhooksUpdateSchema);

export const updateWebhookMutationResponseSchema = z.lazy(() => updateWebhook200Schema);
